
import { Component, Mixins } from 'vue-property-decorator';
import { IBTNCONF } from '@/types/base.d';
import { IMenuForm } from '@/types/set.d';
import bModal from './components/bModal.vue';
import tableMixin from './tableMixin';

@Component({
  components: {
    bModal,
  },
})
export default class MenuView extends Mixins(tableMixin) {
  private actionBtns: Array<IBTNCONF> = [{
    title: '新增',
    name: '/module/menu:add',
    icon: 'plus',
    callback: this.add,
    log: {
      name: '模块管理 - 新增',
      component: 'module/menu/components/bModal',
    },
  }];

  private visible: boolean = false;

  private title: string = '添加模块';

  private form: any = {
  };

  add() {
    this.title = '添加模块';
    this.visible = true;
  }

  // 重写编辑方法
  rowEdit(row: any) {
    this.form = {
      moduleTitle: row.moduleTitle,
      moduleSeq: row.moduleSeq,
      moduleFolder: row.moduleFolder,
      modulePath: row.modulePath,
      pid: row.pid,
    };
    this.title = '编辑模块';
    this.visible = true;
  }
}
